import React, {PropTypes} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import selectAllProps from './selectors';
import {
    MenuItem,
    RaisedButton
} from 'material-ui';
import {TextField, SelectField} from 'redux-form-material-ui';

class UserForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit} autoComplete="false">
                <Field
                    name="password"
                    component={TextField}
                    hintText="Mot de passe"
                    floatingLabelFixed
                    floatingLabelText="Mot de passe"
                    type="password"
                    style={{width: '100%'}}
                />
                <Field
                    name="password_confirmation"
                    component={TextField}
                    hintText="Confirmation de mot de passe"
                    floatingLabelFixed
                    floatingLabelText="Confirmation de mot de passe"
                    type="password"
                    style={{width: '100%'}}
                />
                <div style={{display: 'inline-block', width: '100%', position: 'relative'}}>
                    <RaisedButton type="submit" label="Mettre à jour" primary
                                  disabled={this.props.pristine || this.props.submitting}/> &nbsp;
                    <RaisedButton label="Réinitiliser" secondary disabled={this.props.pristine || this.props.submitting} onClick={this.props.reset}/>
                </div>
            </form>
        );
    }
}

UserForm.propTypes = {
    user: PropTypes.object,
    roles: PropTypes.array,
    errors: PropTypes.array,
    reset: PropTypes.func,
    pristine: PropTypes.bool,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool
};

export default connect(selectAllProps)(reduxForm({form: 'userForm'})(UserForm));


/** WEBPACK FOOTER **
 ** ./src/form/UserPasswordForm/index.js
 **/